/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_AcceptingInputs */

const en_delivery_board_accepting = /** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepting Orders`)
};

const es_delivery_board_accepting = /** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptando Pedidos`)
};

const fr_delivery_board_accepting = /** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptation des commandes`)
};

const de_delivery_board_accepting = /** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akzeptiert Bestellungen`)
};

const id_delivery_board_accepting = /** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menerima Pesanan`)
};

/** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */
const ja_delivery_board_accepting = en_delivery_board_accepting;

/** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */
const zh_delivery_board_accepting = en_delivery_board_accepting;

/** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */
const ar_delivery_board_accepting = en_delivery_board_accepting;

/** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */
const it_delivery_board_accepting = en_delivery_board_accepting;

/** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */
const ru_delivery_board_accepting = en_delivery_board_accepting;

/** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */
const pt_delivery_board_accepting = en_delivery_board_accepting;

/** @type {(inputs: Delivery_Board_AcceptingInputs) => LocalizedString} */
const ko_delivery_board_accepting = en_delivery_board_accepting;

/**
* | output |
* | --- |
* | "Accepting Orders" |
*
* @param {Delivery_Board_AcceptingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_accepting = /** @type {((inputs?: Delivery_Board_AcceptingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_AcceptingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_accepting(inputs)
	if (locale === "es") return es_delivery_board_accepting(inputs)
	if (locale === "fr") return fr_delivery_board_accepting(inputs)
	if (locale === "de") return de_delivery_board_accepting(inputs)
	if (locale === "ja") return ja_delivery_board_accepting(inputs)
	if (locale === "zh") return zh_delivery_board_accepting(inputs)
	if (locale === "ar") return ar_delivery_board_accepting(inputs)
	if (locale === "id") return id_delivery_board_accepting(inputs)
	if (locale === "it") return it_delivery_board_accepting(inputs)
	if (locale === "ru") return ru_delivery_board_accepting(inputs)
	if (locale === "pt") return pt_delivery_board_accepting(inputs)
	return ko_delivery_board_accepting(inputs)
});